import Route from 'mewe/routes/route';
import Session from 'mewe/shared/session';
import { inject as service } from '@ember/service';

export default class JoinPageRoute extends Route {
  @service router;

  async beforeModel(transition) {
    let { isAuthenticated } = await Session.isAuthenticated();
    if (isAuthenticated) {
      this.router.transitionTo('app.page', transition.to.params.url_id);
    } else {
      this.router.transitionTo('login', { queryParams: { next: `/${transition.to.params.url_id}` }});
    }
  }
}
